import { signInPath, signUpPath } from './constants';

/** The sign-in page's query parameter naming the page to return to after signing in (Clerk's own name). */
const REDIRECT_PARAM = 'redirect_url';

/** The sign-in address for someone signed out who opened `returnTo` (a path with its query). */
export const signInPathReturningTo = (returnTo: string) => (
  `${signInPath}?${new URLSearchParams({ [REDIRECT_PARAM]: returnTo })}`
);

/** The page `returnTo` names, as a path on this origin, or null. It's parsed the way the browser will
 *  read it (which drops tabs and newlines, so `/%09/evil.com` is `//evil.com`) and kept only when it stays
 *  on this origin, so a crafted link can't send someone elsewhere after they sign in. The sign-in and
 *  sign-up pages themselves are refused, so a link can't loop back to them. */
const inAppPath = (returnTo: string | null): string | null => {
  if (!returnTo?.startsWith('/')) return null;
  try {
    const url = new URL(returnTo, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    if ([signInPath, signUpPath].some((auth) => url.pathname === auth || url.pathname.startsWith(`${auth}/`))) {
      return null;
    }
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
};

/** Splits the sign-in page's query into the page to return to, if it names one in this app, and the rest. */
export const readSignInRedirect = (searchParams: URLSearchParams) => {
  const rest = new URLSearchParams(searchParams);
  const returnTo = inAppPath(rest.get(REDIRECT_PARAM));
  rest.delete(REDIRECT_PARAM);
  return { returnTo, rest: rest.toString() };
};
